import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class GroupLicenseService {

get baseUrl(): string { return Constants.CORE_API_BASE_URL; }  constructor(private http: HttpClient) {}

  getDetailsForPopup(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.baseUrl + 'UserLicense/ShowUserLicenseDetailsForEGAndModule',
      data,
    )
  }
  filterData(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.baseUrl + 'UserLicense/ShowUserLicenseInfoForEG',
      data,
    )
  }}
